export function safeParse<T>(text: string) {
  try {
    return JSON.parse(text) as T
  } catch (e) {
    return undefined
  }
}
